export default {
  deleteField(customerId, layoutId, payload) {
    return axios.post(`/banner/${customerId}/group/${layoutId}/delete-add-field`, payload)
  }
}
